import './style.css';

export const TypingDots = () => {
  return (
    <div className="typing">
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
};
